import { Card, Icon } from "@stellar/design-system";

import { EmbeddedWalletAssetLogo } from "@/components/EmbeddedWalletAssetLogo";

import { formatRegistrationContactType } from "@/helpers/formatRegistrationContactType";

import { RegistrationContactType } from "@/types";

interface SummaryRowProps {
  walletName?: string;
  assetCode?: string;
  registrationContactType?: RegistrationContactType;
}

const getContactTypeIcon = (type: RegistrationContactType | undefined): React.ReactElement => {
  if (type?.includes("PHONE_NUMBER")) return <Icon.Phone01 />;
  if (type?.includes("WALLET_ADDRESS")) return <Icon.CreditCard01 />;
  return <Icon.Mail01 />;
};

export const SummaryRow = ({ walletName, assetCode, registrationContactType }: SummaryRowProps) => (
  <Card>
    <div className="DisbursementSummaryRow">
      <div className="DisbursementSummaryRow__item">
        <div className="DisbursementSummaryRow__icon DisbursementSummaryRow__icon--wallet">
          <Icon.Wallet01 />
        </div>
        <div className="DisbursementSummaryRow__text">
          <span className="DisbursementSummaryRow__label">Wallet provider</span>
          <span className="DisbursementSummaryRow__value">{walletName || "-"}</span>
        </div>
      </div>

      <div className="DisbursementSummaryRow__divider" aria-hidden="true" />

      <div className="DisbursementSummaryRow__item">
        <EmbeddedWalletAssetLogo assetCode={assetCode ?? ""} size="lg" />
        <div className="DisbursementSummaryRow__text">
          <span className="DisbursementSummaryRow__label">Asset</span>
          <span className="DisbursementSummaryRow__value">{assetCode || "-"}</span>
        </div>
      </div>

      <div className="DisbursementSummaryRow__divider" aria-hidden="true" />

      <div className="DisbursementSummaryRow__item">
        <div className="DisbursementSummaryRow__icon DisbursementSummaryRow__icon--invitation">
          {getContactTypeIcon(registrationContactType)}
        </div>
        <div className="DisbursementSummaryRow__text">
          <span className="DisbursementSummaryRow__label">Invitation method</span>
          <span className="DisbursementSummaryRow__value">
            {formatRegistrationContactType(registrationContactType) || "-"}
          </span>
        </div>
      </div>
    </div>
  </Card>
);

